module.exports = "/images/km.svg?488108e6880cab1061caf60a2645282f";